export default __webpack_public_path__ + "static/media/general_folder.13b0f99a.svg";